module.exports = __webpack_public_path__ + "img/businessman.30cfb9e4.svg";